export default "__VITE_ASSET__igFmNZHL__"